export const testspieleID = 316949;
export const preseasonID = 316755;
export const CHL_LEAGUE_ID = '729967';
